"use client";
import Link from "next/link";
import { useState, useEffect } from "react";

export const Button = ({
  aria,
  children,
  url,
  innerClasses,
  classes,
  ref,
  styles,
  target,
  rel,
}) => {
  const [isInternal, setIsInternal] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const isSameDomain =
        new URL(url, window.location.origin).host === window.location.host;
      setIsInternal(isSameDomain);
    }
  }, [url]);

  // Function to process classes and replace !text-white with text-blue when !bg-transparent is present
  const processClasses = (classString) => {
    if (!classString) return classString;
    
    const hasTransparentBg = classString.includes('!bg-transparent');
    const hasTextWhite = classString.includes('!text-white');
    
    if (hasTransparentBg && hasTextWhite) {
      return classString.replace('!text-white', 'text-blue');
    }
    
    return classString;
  };

  return (
    <>
      {isInternal ? (
        <Link
          aria-label={aria ?? children}
          scroll={true}
          className={"GlobalButton mt-[50px] lg:py-[10px] " + classes}
          href={url}
          target={target}
          rel={rel}
        >
          <div
            style={styles}
            className={
              "buttonHover  flex justify-center items-center h-[100%] relative rounded-full bg-[#1757A3] font-semibold text-[18px] px-12 py-3.5 text-white " +
              processClasses(innerClasses)
            }
          >
            {children}
          </div>
        </Link>
      ) : (
        <Link
          aria-label={aria ?? children}
          scroll={true}
          className={"GlobalButton mt-[50px] lg:py-[10px] " + classes}
          href={url}
          target={target || "_blank"}
          rel={rel || "noopener noreferrer"}
        >
          <div
            style={styles}
            className={`buttonHover h-[100%] relative rounded-full bg-[#1757A3] font-semibold text-[18px] px-12 py-3.5 text-white ${processClasses(innerClasses)}`}
          >
            {children}
          </div>
        </Link>
      )}
    </>
  );
};
